// extracted by css-extract-rspack-plugin
export default {"horizontal":"Sl2sm","vertical":"OAvck"};